import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const receiptApi = {
  markRead: (conversationId, readSeq) =>
    imRequest.put(`${IM_API}/conversations/${conversationId}/read`, { readSeq }),

  getMine: (conversationId) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/read`),

  listStates: (conversationId, params = {}) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/read-states`, { params }),
};
